import { createStyles, Theme } from "@material-ui/core";
export const dialogTopNav = (theme: Theme) =>
  createStyles({   
    navBar: {
        padding: '18px 12px 0px',
        // position: 'relative',
        '& .label': {
            color: '#999',
            verticalAlign: 4,
            fontWeight: 600
        },
        '& .subLabel': {
            // color: '#666',
            verticalAlign: 4,
            fontWeight: 600,
        },
        '& .red': {
          color: '#F23C3C!important'
        },
         '& .darkYellow': {
          color: '#FB9E2E!important'
        }, 
         '& .yellow': {
          color: '#FFD016!important'
        },      
         '& .green': {
          color: '#30BE76!important'
        },
        '& .Assigned_by': {
          fontWeight:600,
          color: "#333",          
        },
        
        '&>:last-child':{
          // position: "absolute",
          // right:12,
          // marginTop:-5,
        },
      '&>:nth-child(n+3)': {
        '&>:first-child': {
          '& .textEllipse':{
            padding: "0px 10px 0px 0",
            // whiteSpace: "nowrap",
            // overflow: "hidden",
            // width: 120,
           // textOverflow: "ellipsis",
            // display: "inline-block",
            // verticalAlign: '-2px'
          },
          '& .colorGray':{
            color: '#666'
          },
        }
      }
    },
  
  });

